import React from "react";
import { isEmpty } from "lodash";
import { toast } from "react-toastify";
import "../styles/ForgotPassword.css";
import EmailIcon from "../assets/SVG/icons/email-icon.svg";
import ErrorIcon from "../assets/SVG/icons/error-icon.svg";
import EyeIconOn from "../assets/SVG/icons/eye-icon-active.svg";
import EyeIconOff from "../assets/SVG/icons/eye-icon.svg";
import BackIcon from "../assets/SVG/buttons/back-button.svg";
import successPng from "../assets/images/success.png";
import { forgotPasswordRequest, resetPassword } from "../api";

class ForgotPassword extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isCreateNewPassword: this.props.isCreateNewPassword || false,
      isEmailRequestSent: this.props.isEmailRequestSent || false,
      showPassword: false,
      isPassInvalid: false,
      isEmailInvalid: false,
      isPassNull: false,
      showConfirmPassword: false,
      email: this.props.email || "",
      password: "",
      confirmPassword: "",
      isPasswordEmpty: false,
      isEmailEmpty: false,
      isConfirmPasswordEmpty: false,
      passwordMatchError: false,
    };
  }

  showPasswordHandler = () => {
    this.setState({ showPassword: !this.state.showPassword });
  };
  showConfirmPasswordhandler = () => {
    this.setState({ showConfirmPassword: !this.state.showConfirmPassword });
  };

  setPassword = (event) => {
    this.setState({ password: event.target.value });
  };
  setConfirmPassword = (event) => {
    this.setState({ confirmPassword: event.target.value });
  };
  setEmail = (event) => {
    this.setState({ email: event.target.value });
  };
  notifyError = (msg) => {
    toast.dismiss();
    toast.error(msg);
  };

  emailContinueHandler = async () => {
    this.setState((prevState) => ({
      ...prevState,
      isEmailEmpty: false,
      isEmailInvalid: false,
    }));
    if (isEmpty(this.state.email)) return this.setState({ isEmailEmpty: true });
    if (!this.isValidEmail(this.state.email)) return this.setState({ isEmailInvalid: true });
    // Call password reset
    await forgotPasswordRequest(this.state.email);
    return this.setState({ isEmailRequestSent: true });
  };
  resetPasswordHandler = async () => {
    this.setState((prevState) => ({
      ...prevState,
      isPasswordEmpty: false,
      isPassInvalid: false,
      passwordMatchError: false,
    }));
    if (isEmpty(this.state.password)) return this.setState({ isPasswordEmpty: true });
    if (!this.isValidPassword(this.state.password)) return this.setState({ isPassInvalid: true });
    if (this.state.password !== this.state.confirmPassword) return this.setState({ passwordMatchError: true });

    // Call password change api
    const resetPasswordResp = await resetPassword(
      this.props.match.params.uid,
      this.props.match.params.token,
      this.state.password
    );

    // If success push it to login page along with toastnotification
    if (resetPasswordResp.success) {
      return this.goToLoginPasswordChangeSuccess();
    } else {
      this.notifyError("Invalid Token");
    }
  };

  isValidEmail = (text) => {
    let re =
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return text.toLowerCase().match(re);
  };
  isValidPassword = (text) => {
    const passwordRegex = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[ !"#$%&'()*+,-./:;<=>?@[\]^_`{|}~]).{8,}$/;
    return text.match(passwordRegex);
  };
  goToLogin = () => {
    this.props.history.push("/login");
  };
  goToLoginPasswordChangeSuccess = () => {
    const location = {
      pathname: "/login",
      state: { passwordReset: true },
    };
    this.props.history.push(location);
  };
  render() {
    if (this.state.isEmailRequestSent) {
      return (
        <div className="forgot-password-container" data-testid="email-request-sent">
          <div className="go-back">
            <img src={BackIcon} alt="covid-test" onClick={this.goToLogin} data-testid="goback-cta" />
          </div>
          <div className="heading-forgot-password">Check your email</div>
          <div className="description">
            <span>Password reset steps were sent to the email if it matches our records.</span>
          </div>
          <div className="img-verified">
            <img src={successPng} alt="sucess" />
          </div>
        </div>
      );
    }
    if (this.state.isCreateNewPassword) {
      return (
        <div className="forgot-password-container" data-testid="password-reset">
          <div className="go-back">
            <img src={BackIcon} alt="covid-test" onClick={this.goToLogin} data-testid="goback-cta" />
          </div>
          <div className="heading-create-password">Create new password</div>
          <div className="form-group password">
            <label className="label">Password *</label>
            <div className="input-box">
              <input
                type={this.state.showPassword ? "text" : "password"}
                id="password"
                className={
                  "form-control " +
                  (this.state.password ? "navy-text " : "") +
                  (this.state.isPasswordEmpty || this.state.isPassInvalid ? "red-border " : "")
                }
                placeholder="Password"
                data-testid="input-password"
                value={this.state.password}
                onChange={this.setPassword}
                required
              />
              <img
                src={this.state.showPassword ? EyeIconOn : EyeIconOff}
                alt="password icon"
                className="pointer"
                data-testid="pointer-password"
                onClick={this.showPasswordHandler}
              />
            </div>
            {this.state.isPasswordEmpty && (
              <div className="password-empty">
                <img className="password-empty-img" src={ErrorIcon} alt="password" />
                <div className="password-empty-text" data-testid="password-empty-text">Password is Required</div>
              </div>
            )}
            {this.state.isPassInvalid && (
              <React.Fragment>
                <div data-testid="InvalidPassword">
                  <img src={ErrorIcon} alt="invalidPassword" />
                  Password should contain:{" "}
                </div>
                <ul className="invalid-password">
                  <li>At least 1 uppercase character</li>
                  <li>At least 1 lowercase character</li>
                  <li>At least 1 numeric character</li>
                  <li>At least 1 special character</li>
                  <li>Length must be at least 8 characters</li>
                </ul>
              </React.Fragment>
            )}
          </div>

          <div className="form-group confirm-password">
            <label className="label">Confirm Password *</label>
            <div className="input-box">
              <input
                type={this.state.showConfirmPassword ? "text" : "password"}
                id="confirmPassword"
                className={
                  "form-control " +
                  (this.state.confirmPassword ? "navy-text " : "") +
                  (this.state.passwordMatchError ? "red-border " : "")
                }
                placeholder="Password"
                data-testid="input-confirm-password"
                value={this.state.confirmPassword}
                onChange={this.setConfirmPassword}
                required
              />
              <img
                src={this.state.showConfirmPassword ? EyeIconOn : EyeIconOff}
                alt="confirm password icon"
                className="pointer"
                data-testid="pointer-confirm-password"
                onClick={this.showConfirmPasswordhandler}
              />
            </div>
            {this.state.passwordMatchError && (
              <div className="password-match">
                <img className="password-match-img" src={ErrorIcon} alt="password" />
                <div className="password-match-text" data-testid="password-match-text">Passwords don't match</div>
              </div>
            )}
          </div>
          <div className="reset-continue-button">
            <button data-testid="continue-button" onClick={this.resetPasswordHandler}>Continue</button>
          </div>
        </div>
      );
    }
    return (
      <div className="forgot-password-container" data-testid="forgot-password">
        <div className="go-back">
          <img src={BackIcon} alt="covid-test" onClick={this.goToLogin} data-testid="goback-cta" />
        </div>
        <div className="heading-forgot-password">Forgot your password</div>
        <div className="description">
          <span>
            Enter the email address associated with your account and we will send you a link to reset password.
          </span>
        </div>
        <div className="email-container">
          <label htmlFor="email-address" className="form-label">
            E-mail
          </label>
          <div className="email-input">
            <input
              type="email"
              className="form-control"
              id="email-address"
              data-testid="email-input"
              placeholder="e-mail@address.com"
              onChange={this.setEmail}
            />
            <img className="email-icon" src={EmailIcon} alt="email icon" />
          </div>
          {this.state.isEmailEmpty && (
            <div className="email-empty">
              <img className="email-empty-img" src={ErrorIcon} alt="email" />
              <div className="email-empty-text"  data-testid="email-empty-text">Email is Required</div>
            </div>
          )}
          {this.state.isEmailInvalid && (
            <div className="email-invalid">
              <img className="email-invalid-img" src={ErrorIcon} alt="email" />
              <div className="email-invalid-text" data-testid="email-invalid-text">Invalid Email!</div>
            </div>
          )}
        </div>
        <div className="continue-button">
          <button data-testid="continue-button" onClick={this.emailContinueHandler}>Continue</button>
        </div>
      </div>
    );
  }
}

export default ForgotPassword;
